export const SUPPORT_EMAIL = 'support@bupnetwork.com';

export const ROLES = {
  company: 'COMPANY',
  influencer: 'INFLUENCER',
};

export default ROLES;
